module.exports = __webpack_public_path__ + "img/high.0d5a8efd.png";